import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import LandingIntro from "./LandingIntro";
import ErrorText from "../../components/Typography/ErrorText";
import InputText from "../../components/Input/InputText";
import { useAuth } from "../../app/auth";
import { useNavigate } from "react-router-dom";
import Tweeter from "../../assets/tweeter.png";

function Login() {
  const INITIAL_LOGIN_OBJ = {
    password: "",
    emailId: "",
  };

  // eslint-disable-next-line
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loginObj, setLoginObj] = useState(INITIAL_LOGIN_OBJ);
  const auth = useAuth();
  const navigate = useNavigate();
  // eslint-disable-next-line
  const [showEmailLogin, setShowEmailLogin] = useState(false);

  useEffect(() => {
    // 👆 daisy UI themes initialization
    if (auth.user) navigate("/app/dashboard");

    //eslint-disable-next-line
  }, [auth.user]);

  // const submitForm = (e) =>{
  //     e.preventDefault()
  //     setErrorMessage("")

  //     if(loginObj.emailId.trim() === "")return setErrorMessage("Email Id is required! (use any value)")
  //     if(loginObj.password.trim() === "")return setErrorMessage("Password is required! (use any value)")
  //     else{
  //         setLoading(true)
  //         // Call API to check user credentials and save token in localstorage
  //         localStorage.setItem("token", "DumyTokenHere")
  //         setLoading(false)

  //     }
  // }

  //eslint-disable-next-line
  const updateFormValue = ({ updateType, value }) => {
    setErrorMessage("");
    setLoginObj({ ...loginObj, [updateType]: value });
  };

  return (
    <div className="min-h-screen bg-base-200 flex items-center">
      <div className="card mx-auto w-full max-w-5xl  shadow-xl">
        <div className="grid  md:grid-cols-2 grid-cols-1  bg-base-100 rounded-xl">
          <div className="">
            <LandingIntro />
          </div>
          <div className="bg-base-200  p-10">
            <div className=" py-5 px-10 bg-base-100 rounded-lg shadow-2xl">
              <h2 className="text-2xl font-semibold mb-2 text-center pb-10">
                Sign In to Get Started
              </h2>

              <form>
                <div className="relative">
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      setLoading(true);
                      auth.signinWithGoogle();
                    }}
                    className=" border rounded-lg w-full py-3 px-4 flex items-center space-x-2 shadow-md"
                  >
                    <span className="w-6 h-6">
                      <img
                        src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 48 48'%3E%3Cdefs%3E%3Cpath id='a' d='M44.5 20H24v8.5h11.8C34.7 33.9 30.1 37 24 37c-7.2 0-13-5.8-13-13s5.8-13 13-13c3.1 0 5.9 1.1 8.1 2.9l6.4-6.4C34.6 4.1 29.6 2 24 2 11.8 2 2 11.8 2 24s9.8 22 22 22c11 0 21-8 21-22 0-1.3-.2-2.7-.5-4z'/%3E%3C/defs%3E%3CclipPath id='b'%3E%3Cuse xlink:href='%23a' overflow='visible'/%3E%3C/clipPath%3E%3Cpath clip-path='url(%23b)' fill='%23FBBC05' d='M0 37V11l17 13z'/%3E%3Cpath clip-path='url(%23b)' fill='%23EA4335' d='M0 11l17 13 7-6.1L48 14V0H0z'/%3E%3Cpath clip-path='url(%23b)' fill='%2334A853' d='M0 37l30-23 7.9 1L48 0v48H0z'/%3E%3Cpath clip-path='url(%23b)' fill='%234285F4' d='M48 48L17 24l-4-3 35-10z'/%3E%3C/svg%3E"
                        alt="Google Icon"
                        width="24"
                        height="24"
                      />
                    </span>
                    <span>Continue with Google</span>
                  </button>
                </div>

                <div className="relative mt-5">
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      setLoading(true);
                      auth.signinWithTwitter();
                    }}
                    className=" border rounded-lg w-full py-3 px-4 flex items-center space-x-2 shadow-md"
                  >
                    <span className="w-6 h-6">
                      <img
                        src={Tweeter}
                        alt="Google Icon"
                        width="24"
                        height="24"
                      />
                    </span>
                    <span>Continue with Twitter</span>
                  </button>
                </div>
              </form>

              { showEmailLogin && (
                <>
                <div className="py-8 relative ">
                <div className="absolute inset-0 flex items-center">
                  <div className="w-1/2 border-t "></div>

                  <span className=" px-2 ">OR</span>
                  <div className="w-1/2 border-t"></div>
                </div>
              </div>
              <form
              className="email-password-form"
                onSubmit={(e) => {
                  e.preventDefault(); // Prevent default form submission
                  auth.signInWithEmailandPass(
                    loginObj.emailId,
                    loginObj.password
                  );
                }}
              >
                <InputText
                  inputStyle="w-full"
                  type="emailId"
                  defaultValue={loginObj.emailId}
                  updateType="emailId"
                  containerStyle=""
                  labelTitle="Email"
                  updateFormValue={updateFormValue}
                />

                <InputText
                  inputStyle="w-full"
                  defaultValue={loginObj.password}
                  type="password"
                  updateType="password"
                  containerStyle="mt-4"
                  labelTitle="Password"
                  updateFormValue={updateFormValue}
                />

                <div className="text-right text-primary">
                  <Link to="/forgot-password">
                    <span className="text-sm  inline-block  hover:text-primary hover:underline hover:cursor-pointer transition duration-200">
                      Forgot Password?
                    </span>
                  </Link>
                </div>

                <ErrorText styleClass="mt-8">{errorMessage}</ErrorText>
                {/* <button type="submit" className={"btn mt-2 w-full btn-primary" + (loading ? " loading" : "")}>Login</button> */}

                <button
                  type="submit"
                  // onClick={async (e) => {
                  //   e.preventDefault();
                  //   auth.signInWithEmailandPass(
                  //     loginObj.emailId,
                  //     loginObj.password
                  //   );
                  // }}
                  className={
                    "btn mt-2 w-full btn-primary" + (loading ? " loading" : "")
                  }
                >
                  Login
                </button>

                {/* <div className="text-center mt-4">
                  Don't have an account yet?{" "}
                  <Link to="/register">
                    <span className="  inline-block  hover:text-primary hover:underline hover:cursor-pointer transition duration-200">
                      Register
                    </span>
                  </Link>
                </div> */}
              </form>
                </>)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
